<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <h2>Preguntas Frecuentes (FAQs)</h2>
                </div>

                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li><a routerLink="/">Inicio</a></li>
                        <li>Preguntas</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="protected-area pt-70">
    <div class="container">
        <div class="section-title">
            <h2>General</h2>
        </div>

        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="frequently-content-wrap">
                    <ul>
                        <li>
                            <i class="fa-solid fa-circle-info"></i>
                            <h3>¿Qué es enCloud?</h3>
                            <p>enCloud es una empresa mexicana de computación en la nube que ofrece servicios de almacenamiento de datos, hosting de servidores dedicados y soluciones para videojuegos, machine learning e investigación.</p>
                        </li>
                       <li>
                        <i class="fa-solid fa-cloud"></i>
                        <h3>¿En qué se diferencia enCloud de otros proveedores de servicios en la nube?</h3>
                            <p>enCloud combina tecnología de punta con un enfoque personalizado, ofreciendo servidores diseñados a la medida, resguardo seguro de datos y precios competitivos. Además, desarrollamos nuestras propias tecnologías, como routers especializados, para garantizar máxima eficiencia.</p>
                        </li>
                        <li>
                            <i class="fa-solid fa-map-location-dot"></i>
                            <h3>¿Dónde están ubicados los servidores de enCloud?</h3>
                            <p>Nuestros servidores están ubicados estratégicamente para garantizar un alto rendimiento, seguridad y disponibilidad para todos nuestros clientes, sin importar su ubicación.</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="section-title pt-70">
            <h2>Servicios</h2>
        </div>

        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="frequently-content-wrap">
                    <ul>
                        <li>
                            <i class="fa-solid fa-server"></i>
                            <h3>¿Qué tipos de servidores ofrece enCloud?</h3>
                            <p>Ofrecemos servidores dedicados, servidores para videojuegos, soluciones para machine learning y servidores personalizados según las necesidades de cada cliente.</p>
                        </li>
                       <li>
                            <i class="fa-solid fa-hard-drive"></i>
                            <h3>¿Qué incluye el servicio de resguardo de datos?</h3>
                            <p>Nuestro servicio de resguardo de datos incluye almacenamiento seguro, copias de seguridad automatizadas y acceso rápido a tus datos desde cualquier lugar.</p>
                        </li>
                        <li>
                            <i class="fa-solid fa-laptop-file"></i>
                            <h3>¿Puedo migrar mis servidores actuales a enCloud?</h3>
                            <p>Sí, ofrecemos soporte completo para la migración de servidores. Nuestro equipo técnico puede ayudarte a trasladar tu infraestructura actual a nuestra plataforma de forma segura y eficiente.</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="section-title pt-70">
            <h2>Tecnología y Seguridad</h2>
        </div>

        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="frequently-content-wrap">
                    <ul>
                        <li>
                            <i class="fa-solid fa-file-shield"></i>
                            <h3>¿Qué medidas de seguridad implementa enCloud para proteger mis datos?</h3>
                            <p>Utilizamos cifrado avanzado, firewalls personalizados y monitoreo continuo para garantizar la seguridad de tus datos. Además, nuestros centros de datos cumplen con los más altos estándares internacionales de seguridad.</p>
                        </li>
                       <li>
                            <i class="fa-solid fa-shield-heart"></i>
                            <h3>¿enCloud realiza copias de seguridad automáticas?</h3>
                            <p>Sí, nuestras soluciones incluyen copias de seguridad automáticas configurables para garantizar que tus datos estén protegidos en todo momento.</p>
                        </li>
                        
                    </ul>
                </div>
            </div>
        </div>

        <div class="section-title pt-70">
            <h2>Precios y Contratación</h2>
        </div>

        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="frequently-content-wrap">
                    <ul>
                        <li>
                            <i class="fa-solid fa-file-invoice"></i>
                            <h3>¿Cómo puedo obtener una cotización para los servicios de enCloud?</h3>
                            <p>Puedes contactarnos directamente a través de nuestro sitio web o enviar un correo a nuestro equipo de ventas. Ofrecemos cotizaciones personalizadas según tus necesidades específicas.</p>
                        </li>
                       <li>
                            <i class="fa-solid fa-landmark"></i>
                            <h3>¿Tienen planes para pequeñas empresas o empresas emergentes (startups)?</h3>
                            <p>Sí, contamos con planes diseñados especialmente para pequeñas empresas y startups que buscan soluciones en la nube accesibles y escalables.</p>
                        </li>
                        <li>
                            <i class="fa-solid fa-wallet"></i>
                            <h3>¿Qué métodos de pago aceptan?</h3>
                            <p>Aceptamos pagos con tarjeta de crédito, transferencia bancaria y opciones locales en México.</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="section-title pt-70">
            <h2>Soporte Técnico</h2>
        </div>

        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="frequently-content-wrap">
                    <ul>
                        <li>
                            <i class="fa-solid fa-headset"></i>
                            <h3>¿Qué tipo de soporte técnico ofrecen?</h3>
                            <p>Ofrecemos soporte técnico 24/7 a través de chat, correo electrónico y teléfono para garantizar que siempre tengas ayuda cuando la necesites.</p>
                        </li>
                       <li>
                            <i class="fa-solid fa-user-shield"></i>
                            <h3>¿Qué ocurre si tengo problemas con mi servidor?</h3>
                            <p>Nuestro equipo de soporte resolverá cualquier problema técnico en el menor tiempo posible, priorizando la continuidad de tus operaciones.</p>
                        </li>
                      
                    </ul>
                </div>
            </div>
        </div>

    </div>
</section>

<div class="pt-70">


<app-contact-form [section]="section" [pt]="pt" [pb]="pb" [title]="contact_tile"></app-contact-form>
</div>